import devConfig from './config/amplify/develop';
import prodConfig from './config/amplify/prod';
import stagingConfig from './config/amplify/staging';

const amplifyConfig =
    process.env.REACT_APP_STAGE === 'production'
        ? prodConfig
        : process.env.REACT_APP_STAGE === 'staging'
        ? stagingConfig
        : devConfig;

console.log(`Stage is ${process.env.REACT_APP_STAGE}`);

export default amplifyConfig;
